<v-loading-container>
  <p-table [columns]="cols" [value]="retailerAccountList" [rows]="20" [responsive]="true" [lazy]="true">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns">
          {{ col.header }}
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr>
        <td *ngFor="let col of columns">
          <div *ngIf="col.field == 'checkBoxes'">
            <div class="p-g-12">
              <p-checkbox
                name="group"
                value="{{ rowData['accountId'] }}"
                (onChange)="getRetailerId()"
                [(ngModel)]="selectedRetailer"
                inputId="{{ rowData['accountId'] }}"
              ></p-checkbox>
            </div>
          </div>

          <div>
            {{ rowData[col.field] }}
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</v-loading-container>
